import { isAfter, sub } from 'date-fns';

const AKA_CONSENT_LAST_SEEN_STORAGE_KEY = 'akaConsentLastSeen';

export function getAkaConsentSeenInLast6Months(): boolean {
  const lastSeenDateString = window.localStorage.getItem(
    AKA_CONSENT_LAST_SEEN_STORAGE_KEY,
  );

  if (!lastSeenDateString) {
    return false;
  }

  const lastSeenDate = new Date(Number(lastSeenDateString));
  const sixMonthsAgoDate = sub(new Date(), { months: 6 });

  return isAfter(lastSeenDate, sixMonthsAgoDate);
}

export function setAkaConsentModalLastSeenToday(): void {
  localStorage.setItem(
    AKA_CONSENT_LAST_SEEN_STORAGE_KEY,
    Date.now().toString(),
  );
}
